<div class="container-fluid col-12 text-center bg-1 mobile">
  <nz-spin [nzSpinning]="isLoading">

    <nz-input-group [nzSuffix]="suffixIconSearch" style="margin-bottom: 12px;">
      <input type="text" nz-input [(ngModel)]="inputValue" placeholder="Filter calls" />
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <span nz-icon nzType="search"></span>
    </ng-template>

    <nz-table #callTable [nzData]="calls | filter: inputValue" [nzFrontPagination]="true">
      <thead>
        <tr>
          <th>Date</th>
          <th>Caller Number</th>
          <th>Channel</th>
          <th>Handled By</th>
          <th>Customer</th>
          <th>Quote</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of callTable.data">
          <td>{{ item.dtLogged + 'Z' | date:'yyyy-MM-dd HH:mm' }}</td>
          <td>{{ item.callerNumber }}</td>
          <td>{{ item.channel }}</td>
          <td>{{ item.handledBy || '—' }}</td>
          <td>
            <a *ngIf="item.customerId" [routerLink]="['/customer', item.customerId]">
              {{ item.customerName || item.customerId }}
            </a>
            <span *ngIf="!item.customerId">—</span>
          </td>
          <td>
            <a *ngIf="item.quoteId" [routerLink]="['/pos/v2', item.quoteId]">
              {{ item.quoteRef || item.quoteId }}
            </a>
            <span *ngIf="!item.quoteId">—</span>
          </td>
        </tr>
      </tbody>
    </nz-table>

  </nz-spin>
</div>
